import React from "react";
import { ErrorAlert } from "components/errorAlert/ErrorAlert";
import { getTranslation } from "utils/translation";

export const Error404 = () => {
  return (
    <ErrorAlert
      title={getTranslation("message", "ERROR.PAGE_NOT_FOUND")}
      errorCode={404}
      buttonTitle={getTranslation("resource", "RETURN_TO_MAIN_PAGE")}
      onClick={() => window.location.replace("/")}
    >
      <React.Fragment>
        <p>{getTranslation("message", "ERROR.CHECK_CORRECT_URL")}</p>
      </React.Fragment>
    </ErrorAlert>
  );
};
